import {
  BuildInformationSchema,
  ReadinessResponseSchema,
  type BuildInformation,
  type ReadinessResponse,
} from '@youkuai/contracts';

async function getJson(path: string): Promise<unknown> {
  const response = await fetch(path, { headers: { Accept: 'application/json' } });
  if (!response.ok) {
    throw new Error(`Request failed: ${response.status}`);
  }
  return response.json();
}

export async function getBuildInformation(): Promise<BuildInformation> {
  return BuildInformationSchema.parse(await getJson('/api/meta/build'));
}

export async function getReadiness(): Promise<ReadinessResponse> {
  return ReadinessResponseSchema.parse(await getJson('/api/health/ready'));
}
